import { ENDPOINT } from '~/constants';

import { vestigasAiApi } from '~/services/kyClient';

import { log } from '~/utils';

import {
  type EvaluateOcrModelPerformancePayload,
  type EvaluateOcrModelPerformanceResponse,
} from './types';
import { zodEvaluateOcrModelPerformanceSchema } from './validations';

/**
 * Evaluates OCR model performance on randomly selected PDFs.
 * @param payload - Payload
 * @returns The evaluation result.
 * @see https://fa-vestigas-dev.azurewebsites.net/docs#/Evaluation/evaluate_evaluate_post
 */
export const evaluateOcrModelPerformance = async (
  payload: EvaluateOcrModelPerformancePayload,
) => {
  try {
    const response = await vestigasAiApi
      .post(ENDPOINT.AI.EVALUATE_MODEL_PERFORMANCE(), {
        json: payload,
        validate: {
          body: zodEvaluateOcrModelPerformanceSchema,
        },
      })
      .json<EvaluateOcrModelPerformanceResponse>();

    return response;
  } catch (error) {
    log.error({
      message: 'Error fetching OCR model performance evaluation',
      error,
    });

    // Re-throw the error to propagate it to the calling function.
    throw error;
  }
};
